module.exports = __webpack_public_path__ + "static/media/Davos Seaworth 3.ce795bad.jpg";